<app-toolbar [title]="title" [user]="user" [destination]="destination" [back]="back"></app-toolbar>

<div class="container">
  <div style="vertical-align: middle; padding-bottom: 10px">
    <h1>Centro notifiche</h1>
  </div>
  <div style="text-align: center; vertical-align: middle">
    <button mat-raised-button color="primary" (click)="removeAll()">Rimuovi tutte</button>
  </div>
  <div style="padding-bottom: 35px"></div>
  <mat-card class="mat-elevation-z10">
    <ng-container *ngIf="notifications && notifications.length > 0; else noNotifications">
      <mat-list >
        <mat-list-item *ngFor="let n of notifications">
          <mat-icon mat-list-icon>notifications</mat-icon>
          <div mat-line style="cursor: pointer" (click)="openNotification(n)">
            <ng-container *ngIf="!n.read; else read">
              <strong>{{n.title}}</strong>
            </ng-container>
            <ng-template #read>
              {{n.title}}
            </ng-template>
          </div>
        </mat-list-item>
      </mat-list>
    </ng-container>
    <ng-template #noNotifications>
      <h3 style="text-align: center; margin: auto">Nessuna notifica presente</h3>
    </ng-template>
    <mat-card-content fxLayout="column">

    </mat-card-content>
  </mat-card>
</div>
